// extracted by mini-css-extract-plugin
export default {"info__productsCount":"info_info__productsCount__Bsk8k","info__productsCount_loading":"info_info__productsCount_loading__0Hi7T"};